import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, ListItem, ListItemButton, Switch, Tooltip, Typography, styled } from "@mui/material";
import FormSubmitButton from "@/components/forms/FormSubmitButton";
import Form from "@/components/forms/Form";
import { ISelectItem } from "@/components/forms/inputs/Select";
import { ConfigurationSourceData, ConfigurationSourceDataAllocation, Institution, Participant, ParticipantSourceDataAllocationUpdate } from "@/api/dtos";
import { IReturn } from "@servicestack/client";
import { GroupedVirtuoso } from "react-virtuoso";
import { ComponentProps, FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import InputOnlyField from "@/components/forms/fields/inputOnly/InputOnlyField";
import Checkbox from "@/components/forms/inputs/Checkbox";
import { DateTime } from "luxon";
import { IFormSubmit, InputComponentType, OmitInputProps, useFormActions } from "@ngt/forms-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/pro-duotone-svg-icons";
import { FormError } from "@/errors";
import { AppSettings } from "@/AppSettings";


const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogTitle-root': {
        padding: theme.spacing(2),
        display: 'flex',
        gap: theme.spacing(2),
        justifyContent: 'space-between',
        alignItems: 'center',

        '& > div': {
            display: 'flex',
            alignItems: 'center'
        }
    },
    '& .MuiDialogContent-root': {
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));


const FormButtons = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'flex-end'
}));

export interface ISearchForm extends Record<string, any> {
}

export interface ISearchField<TComponent extends InputComponentType = any>  {
    key: string;
    label: string;
    component: TComponent;
    componentProps: Partial<OmitInputProps<ComponentProps<TComponent>>>
}

interface ISearchDialogProps {
    formData?: ISearchForm;
    searchFields?: ISearchField[];
    open?: boolean;
    onClose?: () => void;
    onSave?: (data?: ISearchForm ) => Promise<any>;
}

const defaultForm = {};

const SearchDialog: FC<ISearchDialogProps> = ({
    formData,
    open,
    searchFields,
    onClose,
    onSave
}) => {
    const submit = useCallback<IFormSubmit<ISearchForm, FormError>>(async (formState, formActions) => {
        await onSave?.(formState.value ?? {});

        onClose?.();

        return {};
    }, [onSave, onClose]);

    return (
        <Form
            initialValue={formData ?? defaultForm}
            onSubmit={submit}
            debug={AppSettings.debug}
        >
            <StyledDialog
                //onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open ?? false}
                maxWidth="xl"
                fullWidth
                scroll="paper"
            >
                <DialogTitle>
                    Search
                </DialogTitle>
                <DialogContent dividers>
                    {
                        open && (
                            searchFields?.map(x => (
                                <InputOnlyField 
                                    key={x.key}
                                    propertyPath={x.key}
                                    component={x.component}
                                    {...x.componentProps}
                                    label={x.label}
                                />
                            ))
                        )
                    }
                </DialogContent>
                <DialogActions>
                        <FormButtons>
                            <FormSubmitButton
                                variant="contained"
                                color="primary"
                            >
                                Ok
                            </FormSubmitButton>
                            { 
                                onClose && (
                                    <Button
                                        variant="contained"
                                        color="inherit"
                                        onClick={onClose}
                                    >
                                        Cancel
                                    </Button>
                                )
                            }
                        </FormButtons>
                </DialogActions>
            </StyledDialog>
        </Form>
    );
}

export default SearchDialog;